import { css } from '@emotion/css'
import { fontSize, fontWeight, shorthandHelper, spacing } from '@offerzen/pinata'

const TEXT_MARGIN = '1em'

const styles = {
  section: css({
    b: {
      fontWeight: fontWeight.medium,
    },
  }),

  heading: css({
    fontWeight: fontWeight.bold,
    fontSize: fontSize.large,
    textAlign: 'center',
    margin: shorthandHelper([spacing.extraLarge, 0]),
  }),

  notification: css({
    marginBottom: spacing.large,

    p: {
      marginTop: 0,
    },

    'p:last-child': {
      marginBottom: 0,
    },

    b: {
      fontWeight: fontWeight.medium,
    },
  }),

  subHeading: css({
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.large,
    marginBottom: spacing.large,
  }),

  subSubHeading: css({
    fontSize: fontSize.medium,
    fontWeight: fontWeight.semiBold,
    margin: shorthandHelper([spacing.medium, 0]),
  }),

  list: css({
    margin: shorthandHelper([0, 0, TEXT_MARGIN]),
  }),

  noMargin: css({
    margin: 0,
  }),

  descriptionList: css({
    dt: {
      float: 'left',
    },

    dd: {
      padding: 0,
      margin: shorthandHelper([TEXT_MARGIN, 0]),
    },
  }),
}

export default styles
